let refreshPromise = null;

export const getNewToken = async (ctx) => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const requestId =
        typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

      const newAuth = await $fetch(`/api/auth/sf_refresh_token?ctx=${ctx}`, {
        headers: {
          "X-Request-Id": requestId,
        },
        method: "POST",
      });
      console.log("New token", newAuth);

      return newAuth?.success;
    } catch (error) {
      console.error("Error while getting new token", error?.statusCode);
      if (error?.status === 401 || error?.statusCode === 401) {
        await useUnAuthorize("4x"); // your logout + redirect helper
      }
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};
/*
export const getNewTokenDebouncedFn = useDebounceFn(
  (ctx) => getNewToken(ctx),
  5000,
  {
    maxWait: 10000,
  }
);
// Simple refresh mutex (per process)
export const useRefreshTokenMutex = defineEventHandler(async () => {
  const nitro = useNitroApp();
  nitro._refreshLock ??= false;
  try {
    if (!nitro._refreshLock) {
      nitro._refreshLock = true;
      const data = await getNewToken("use-token-refresh");
      return data;
    }
  } finally {
    nitro._refreshLock = false;
  }
});

const executing = useState("refresh-tk-exec", () => false);
export const useRefreshTokenState = defineEventHandler(async (ctx) => {
  try {
    if (!executing.value) {
      executing.value = true;
      const data = await getNewToken(ctx);
      return data;
    }
  } finally {
    executing.value = false;
  }
});*/
